<template>
  <div class="games-parent">
    <div
      v-for="game in games"
      :key="game.appid"
    >
      <Game :game="game" />
    </div>
  </div>
</template>

<script>
import Game from "./Game.vue";

export default {
  name: "Games",
  components: {
    Game
  },
  props: {
    games: {
      type: Array,
      default: null
    }
  },
  data: function() {
    return {};
  },
  created: function() {
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.games-parent{
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
}
</style>